// frontend/src/pages/LandingPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';

import bgImage from '../assets/classification-bg.jpg';

const CARDS = [
  {
    id: 'dashboard',
    header: 'Data Dashboard',
    desc: 'This Patient details Dashboard helps you quickly generate and manage reports.It provides easy access to organized patient data. The system improves efficiency and reduces manual work.It ensures secure handling of information. It supports better decision-making with clear insights. Click the button below to access the patient details.',
    cta: 'Click the button below to access your dashboard',
    btnLabel: 'Dashboard',
    route: '/cases',
  },
  {
    id: 'scan',
    header: 'Start Scan',
    desc: 'The Start Scan feature quickly analyzes patient data. It detects patterns and generates accurate results. The system reduces manual work through automation. It ensures secure and reliable data processing. It helps support faster decision-making.',
    cta: 'Click the button below to start scanning.',
    btnLabel: 'Start Scan',
    route: '/patients',
  },
];

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="ldp__root">
      {/* Background image */}
      <div
        className="ldp__bg"
        style={{ backgroundImage: `url(${bgImage})` }}
        aria-hidden="true"
      />

      {/* Cards row */}
      <div className="ldp__cards-row">
        {CARDS.map(card => (
          <div key={card.id} className="ldp__card">
            {/* Header */}
            <div className="ldp__card-header">
              <h2 className="ldp__card-title">{card.header}</h2>
            </div>

            {/* Body */}
            <div className="ldp__card-body">
              <p className="ldp__card-desc">{card.desc}</p>
              <p className="ldp__card-cta text-center">{card.cta}</p>
              <div className="d-flex justify-content-center">
                <button
                  className="ldp__btn"
                  onClick={() => navigate(card.route)}
                >
                  {card.btnLabel}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}